import {Box, Heading, Stack} from '@chakra-ui/react';
import React, {useState, useRef} from 'react';
import FlexCard from '../../components/General/FlexCard';
import {useForm} from 'react-hook-form';
import {SubmitButton} from '../../components/General/FormInputs';
import {FileDropper} from '../../components/Reports/FileDropper';
import {postUpload} from '../../service/ApiService';
import {File} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';

export const ImportReport = () => {
  const [files, setFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [toast, setToast] = useState(undefined);

  const inputRef = useRef('');
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm();
  const handleChange = newFiles => {
    setFiles([]);
    const nFiles = [];
    if (newFiles.length == 1 && newFiles[0].name.toLowerCase().endsWith('.rdlx')) {
      nFiles.push(newFiles[0]);
      setIsDisabled(false);
    } else {
      for (let x = 0; x < newFiles.length; x++) {
        if (newFiles[x].name.toLowerCase().endsWith('.rdlx')) {
          nFiles.push(newFiles[x]);
        } else {
          setToast({response: {error: true}, errorMessage: 'The file "' + newFiles[x].name + '" is not an rdlx file'});
        }
      }
      setIsDisabled(!nFiles.length > 0);
    }
    setFiles(nFiles);
  };
  const importReport = async data => {
    files.forEach(async file => {
      const formData = new FormData();
      formData.append('files', file);
      const response = await postUpload(File.REPORT, formData);
      setToast({response: response, successMessage: 'Successfully uploaded ' + file.name});
    });
  };
  return (
    <div>
      <FlexCard w="90%" m="auto" minW="200px" p="20">
        <Stack mr="auto" w="100%" justify="start">
          <Heading>Import A Report</Heading>
          <form onSubmit={handleSubmit(importReport)}>
            <FileDropper inputRef={inputRef} state={files} setState={setFiles} handleChange={handleChange} />
            <Box>
              <SubmitButton id="formButton" disabled={isDisabled} name="Import Report" />
            </Box>
          </form>
        </Stack>
      </FlexCard>
      <ErrorHelper toastResponse={toast} />
    </div>
  );
};
/* get file from button click, figure out how to upload later. drag and drop possibilility. look for react library. add to admin only router. multi-selector drop down from add/edit uder. submit to print name of report and role of user 
https://www.npmjs.com/package/react-drag-drop-files - issue: needs react 18.0.0. we have react 17.0.2

found another library that I can use.
https://www.npmjs.com/package/react-file-drop
*/
